import { render, staticRenderFns } from "./CompleteRegistration.vue?vue&type=template&id=0d1457ee&scoped=true&"
import script from "./CompleteRegistration.vue?vue&type=script&lang=js&"
export * from "./CompleteRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CompleteRegistration.vue?vue&type=style&index=0&id=0d1457ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1457ee",
  null
  
)

export default component.exports